// CUIT/CUIL: 11 dígitos, los dos primeros dicen el tipo de sujeto y el último
// es verificador (módulo 11 con los pesos 5432765432).

const PESOS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

// Prefijos vigentes. 20/23/24/25/26/27 son personas humanas; 30/33/34, personas
// jurídicas. El 23 y el 33 aparecen cuando el verificador del 20/27 o del 30
// daría 10.
export const PREFIJOS_HUMANA = ['20', '23', '24', '25', '26', '27'] as const;
export const PREFIJOS_JURIDICA = ['30', '33', '34'] as const;

export function normalizarCuit(valor: string): string {
  return valor.replace(/\D/g, '');
}

export function digitoVerificador(primeros10: string): number | null {
  if (!/^\d{10}$/.test(primeros10)) return null;
  let suma = 0;
  for (let i = 0; i < 10; i++) suma += Number(primeros10[i]) * PESOS[i]!;
  const resto = 11 - (suma % 11);
  if (resto === 11) return 0;
  if (resto === 10) return null; // ARCA no emite CUIT con este verificador
  return resto;
}

export function cuitValido(valor: string): boolean {
  const cuit = normalizarCuit(valor);
  if (!/^\d{11}$/.test(cuit)) return false;
  const prefijo = cuit.slice(0, 2);
  if (!(PREFIJOS_HUMANA as readonly string[]).includes(prefijo) &&
      !(PREFIJOS_JURIDICA as readonly string[]).includes(prefijo)) return false;
  return digitoVerificador(cuit.slice(0, 10)) === Number(cuit[10]);
}

export function tipoPersonaPorCuit(valor: string): 'humana' | 'juridica' | null {
  const prefijo = normalizarCuit(valor).slice(0, 2);
  if ((PREFIJOS_HUMANA as readonly string[]).includes(prefijo)) return 'humana';
  if ((PREFIJOS_JURIDICA as readonly string[]).includes(prefijo)) return 'juridica';
  return null;
}

/** 20123456786 → 20-12345678-6. Si no tiene 11 dígitos lo devuelve como vino. */
export function formatearCuit(valor: string): string {
  const cuit = normalizarCuit(valor);
  if (cuit.length !== 11) return valor;
  return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
}
